import { Divider, Stack } from '@mui/material';
import { DoctorsSuppliersContext } from 'Context/SuppliersContext/DoctorsSuppliersContext';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { supplierResourceFilterMapper } from 'Utils/suppliersResources';
import { MoreContactDetails } from '../../Therapy/Details/MoreContactDetails';
import { Languages } from '../../Therapy/Details/Languages';
import { SpecialServices } from '../../Therapy/Details/SpecialServices';
import { ISuppliersResult } from 'API/Suppliers/suppliers';

interface IDetails {
  data: ISuppliersResult;
}
export const Details = ({ data }: IDetails) => {
  const { resources } = useContext(DoctorsSuppliersContext);
  const isDesktop = useIsDesktop();

  const languages: string[] = supplierResourceFilterMapper(
    resources.LNGCD,
    data.languages
  );

  const services: boolean[] = [
    data.hasAccessibilityForHandicapped,
    data.hasHomeVisit,
  ];

  const homePhoneNumber: string | null =
    data.homePhonePrefix && data.homePhoneNumber
      ? `${data.homePhonePrefix}-${data.homePhoneNumber}`
      : null;

  return (
    <>
      {isDesktop && (
        <Divider
          orientation='horizontal'
          sx={{ mb: '24px', borderColor: 'primary.shade_100' }}
          aria-hidden={true}
        />
      )}
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? undefined : '20px'}
        sx={{
          mb: isDesktop ? undefined : '20px',
        }}
      >
        <SpecialServices services={services} />
      </Stack>
      {services.some((service) => service) &&
        (languages.length > 0 || homePhoneNumber || data.email?.length > 0) && (
          <Divider
            orientation='horizontal'
            sx={{ m: '24px 0', borderColor: 'primary.shade_100' }}
            aria-hidden={true}
          />
        )}
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? undefined : '20px'}
      >
        <Languages languagesList={languages} />
        {(data.email || homePhoneNumber) && (
          <MoreContactDetails
            homePhoneNumber={
              data.cellPhonePrefix && data.cellPhoneNumber
                ? homePhoneNumber
                : null
            }
            email={data.email}
          />
        )}
      </Stack>
    </>
  );
};
